module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fRXBU"))).then(() => module.bundle.root('f4eak'));